import {
    ACTION_CONFIRM_PROMPT_UPDATE_STATE,
    ACTION_CONFIRM_PROMPT_UPDATE_READY_TO_SHOW_STATE,
    ACTION_CONFIRM_PROMPT_UPDATE_CONTENT_STATE,
    ACTION_CONFIRM_PROMPT_RESET_STATE,
    ACTION_CONFIRM_PROMPT_UPDATE_CONFIRM_STATUS,
    ACTION_CONFIRM_PROMPT_HIDE_PROMPT,

    ACTION_CONFIRM_PROMPT_MAKE_READY_TO_SHOW,
    ACTION_CONFIRM_PROMPT_DISPLAY_PROMPT
} from './actionTypes';

export const confirmPromptUpdateState = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_UPDATE_STATE,
    payload     :   status
});

export const confrimPromptUpdateReadyToShowState = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_UPDATE_READY_TO_SHOW_STATE,
    payload     :   status
});

export const confirmPromptUpdateContentState = (payload) => ({
    type        :   ACTION_CONFIRM_PROMPT_UPDATE_CONTENT_STATE,
    payload     :   payload
});

export const confirmPromptUpdateConfirmStatus = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_UPDATE_CONFIRM_STATUS,
    payload     :   status
});

export const confirmPromptResetState = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_RESET_STATE,
    payload     :   status
});

export const confirmPromptHidePrompt = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_HIDE_PROMPT,
    payload     :   status
});

export const confirmPromptShow = (status) => ({
    type        :   ACTION_CONFIRM_PROMPT_DISPLAY_PROMPT,
    payload     :   status
});

